import { prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useSnackbar } from '#hooks';
import services from '#services';
import { actions } from '#store';

const useOrders = () => {
  const { enqueueErrorSnackbar } = useSnackbar();
  const state = useSelector(prop('orders'));
  const dispatch = useDispatch();

  const fetchStringQuery = useCallback(async (query, { enableSnackbar } = {}) => {
    try {
      dispatch(actions.orders.fetch.creator());
      const orders = await services.bob.orders.fetchStringQuery(query);
      dispatch(actions.orders.fetchSuccess.creator({ payload: orders }));
      return orders;
    } catch (err) {
      dispatch(actions.orders.fetchError.creator({ error: err.message }));
      if (enableSnackbar) {
        enqueueErrorSnackbar(err.message, {
          persist: true,
          buttons: [{
            text   : 'retry',
            onClick: () => fetchStringQuery(query, { enableSnackbar }),
          }],
        });
        return [];
      }
      throw err;
    }
  }, [dispatch]);

  const setFilters = useCallback(filters => dispatch(
    actions.orders.setFilters.creator(filters)
  ), [dispatch]);

  return {
    ...state,
    handlers: {
      fetchStringQuery,
      setFilters,
    },
  };
};

export default useOrders;
